import { Routes } from '@angular/router';
import { authGuard } from '@brightside/core/auth';
import { featureFlagGuard, FeatureFlagKey } from '@brighthub/feature-flags';
import { AskNaviLayoutComponent } from '../layout/ask-navi-layout.component';

/** Top-level routes for the Ask Navi subapp. */
export const AskNaviRoutes: Routes = [
  {
    path: 'ask-navi',
    canMatch: [
      featureFlagGuard(FeatureFlagKey.ENABLEASKNAVI, {
        redirectTo: '/brightnav/myclients',
      }),
    ],
    canActivate: [authGuard],
    component: AskNaviLayoutComponent,
  },
];
